<template>
  <template v-if="dependenciesReport && !loading">
    <vl-title v-if="title" tag-name="h1"> {{ title }} </vl-title>
    <DependencyTable
      v-if="showDeliveryProcessDefinitions"
      entity-type="deliveryprocessdefinition"
      :items="deliveryProcessDefinitions"
      :title="$t('entitymodel.dependencies.deliveryProcessDefinitions.title')"
      :no-results-text="$t('entitymodel.dependencies.deliveryProcessDefinitions.noResults')"
    />
    <DependencyTable
      v-if="showProductProcessDefinitions"
      entity-type="productprocessdefinition"
      :items="productProcessDefinitions"
      :title="$t('entitymodel.dependencies.productProcessDefinitions.title')"
      :no-results-text="$t('entitymodel.dependencies.productProcessDefinitions.noResults')"
    />
  </template>
  <template v-if="loading">
    <vl-region>
      <vl-loader :message="$t('entitymodel.dependencies.loading')" />
    </vl-region>
  </template>
</template>
<script lang="ts" setup>
import {
  DeliveryProcessDefinitionBasicDto,
  EntityModelDependenciesReportDto,
  ProductProcessDefinitionBasicDto
} from '@/api/backoffice/clients';
import { useEntityModelDetailStore } from '@/modules/configuration/store/entity-model/entity-model-detail.store';
import { computed, onMounted, reactive } from 'vue';
import DependencyTable from '@/modules/configuration/views/shared/DependencyTable.vue';

const store = useEntityModelDetailStore();

const props = defineProps({
  id: {
    type: Number,
    required: true
  },
  title: {
    type: String,
    default: ''
  },
  showDeliveryProcessDefinitions: {
    type: Boolean,
    default: true
  },
  showProductProcessDefinitions: {
    type: Boolean,
    default: true
  }
});

const data = reactive({
  isLoading: false
});

const loading = computed(() => {
  return data.isLoading;
});

const dependenciesReport = computed((): EntityModelDependenciesReportDto => {
  return store.dependenciesReport;
});

const deliveryProcessDefinitions = computed((): DeliveryProcessDefinitionBasicDto[] => {
  return dependenciesReport.value?.deliveryProcessDefinitions;
});

const productProcessDefinitions = computed((): ProductProcessDefinitionBasicDto[] => {
  return dependenciesReport.value?.productProcessDefinitions;
});

onMounted(async () => {
  data.isLoading = true;
  await store.getDependenciesReport(props.id);
  data.isLoading = false;
});
</script>
<style lang="scss" scoped></style>
